import { requestConfig } from "../config.js";

/**
 * Создать процесс для ФЛ
 *
 * @param {String} customerKey
 * @param {Number} streetId
 * @param {Number} houseId
 * @param {?String} flatNumber
 * @param {String} userFullName
 * @param {String} phoneNumber
 * @param {String} userId
 * @param {String} roistatVisitId
 * @param {String} company
 */
export async function apiCreateProcess(
  customerKey,
  streetId,
  houseId,
  flatNumber = null,
  userFullName,
  phoneNumber,
  userId,
  roistatVisitId,
  company
) {
  const response = await requestConfig.post("/api/v0/master/mobile_connect/create_process/", {
    key: customerKey,
    street_id: streetId,
    house_id: houseId,
    flat: flatNumber,
    full_name: userFullName,
    phone: phoneNumber,
    ref_user_id: userId,
    roistat: roistatVisitId,
    company: company,
  });

  return response.data?.detail;
}

/**
 * Создать процесс для ЮЛ
 *
 * @param {?Number} streetId
 * @param {?Number} houseId
 * @param {String} userFullName
 * @param {?String} userFullAddress
 * @param {String} phoneNumber
 * @param {Array<Number>} serviceList
 * @param {?String} userId
 * @param {String} roistatVisitId
 * @param {?String} comment
 *
 */
export default async function apiCreateProcessBusiness(
  streetId,
  houseId,
  userFullName,
  userFullAddress,
  phoneNumber,
  serviceList,
  userId,
  roistatVisitId,
  comment = ""
) {
  const response = await requestConfig.post("/api/v0/master/mobile_connect/ul_create_process/", {
    street_id: streetId,
    house_id: houseId,
    full_name: userFullName,
    full_address: userFullAddress,
    phone: phoneNumber,
    services: serviceList,
    ref_user_url: userId,
    roistat: roistatVisitId,
    description: comment,
  });

  return response.data?.detail;
}

/**
 * Записать данные в процесс
 *
 * @param {String} apiKey
 * @param {Object} paramsProcess
 */
export async function apiChangeProcess(apiKey, paramsProcess) {
  await requestConfig.patch("/api/v0/master/mobile_connect/process_info/", {
    key: apiKey,
    value: {
      has_payment:
        typeof paramsProcess.has_payment === "undefined" ? null : paramsProcess.has_payment,
      has_auth: typeof paramsProcess.has_auth === "undefined" ? null : paramsProcess.has_auth,
      cost_services:
        typeof paramsProcess.cost_services === "undefined" ? null : paramsProcess.cost_services,
    },
  });
}

/**
 * Получить данные из процесса
 *
 * @param {String} apiKey
 * @param {Array<String>} nameFields
 */
export async function apiFetchProcess(apiKey, nameFields) {
  const response = await requestConfig.post("/api/v0/master/mobile_connect/process_info/", {
    key: apiKey,
    value: nameFields,
  });

  if (!response?.data) throw new Error("Unable to fetch details a process");

  const {
    has_auth,
    se_data,
    cost_connection,
    cost_services,
    contract,
    address,
    number_months,
    limitation,
    network_type,
  } = response.data.detail;

  return {
    hasAuth: has_auth,
    seData: se_data,
    costConnection: cost_connection,
    costServices: cost_services,
    contract: contract,
    address: address,
    numberMonths: number_months,
    limitation: limitation,
    networkType: network_type,
  };
}

/**
 * Получить статус процесса
 *
 * @param {String} processKey
 */
export async function apiFetchStatusProcess(processKey) {
  const response = await requestConfig.post("/api/v0/master/status_process/", {
    process_key: processKey,
  });

  return response.data?.detail?.status;
}

/**
 * Создать процесс на выезд и получить доступное время для выезда
 *
 * @param {String} apiKey
 * @param {Number} date
 */
export async function apiCreateProcessEngineer(apiKey, date) {
  const response = await requestConfig.get("/api/v0/master/mobile_connect/engineer_process/", {
    params: {
      key: apiKey,
      date: date,
    },
  });

  return response.data?.detail;
}

/**
 * Установить дату и время в процессе на выезд сервис-инженера
 *
 * @param {String} apiKey
 * @param {Number} date
 */
export async function apiChangeProcessEngineer(apiKey, date) {
  await requestConfig.post("/api/v0/master/mobile_connect/engineer_process/", {
    key: apiKey,
    date: date,
  });
}

/**
 * Создать процесс на обратный звонок в ERP.
 * Город и комментарий могут отсутствовать в зависимости от UI-формы
 *
 * @param {String} userFullName
 * @param {String} userPhoneNumber
 * @param {String} userAddress
 * @param {?String} city
 * @param {?String} userComment
 */
export async function apiCreateProcessSupport(
  userFullName,
  userPhoneNumber,
  userAddress,
  city = "",
  url,
  userComment = ""
) {
  const response = await requestConfig.post("/api/v0/master/create_otm_process/", {
    app_key: process.env.REACT_APP_KEY,
    data: {
      name: userFullName,
      phone: userPhoneNumber,
      address: userAddress,
      // Значение для параметра "Источник заявки" в ERP, где 1 - это сайт
      source: "1",
      city: city,
      comment: userComment,
      url_from: url,
    },
  });

  return response.data;
}
